import React__default from 'react';
import { ReactComponent as SvgBreadcrumbLeftArrow } from '../images/breadcrumb-left-arrow.svg.esm.js';
import { ReactComponent as SvgBreadcrumbRightArrow } from '../images/breadcrumb-right-arrow.svg.esm.js';

var ArticleBreadcrumbs = function ArticleBreadcrumbs(props) {
  if (props.breadcrumbElements) {
    return /*#__PURE__*/React__default.createElement("ol", {
      "automation-id": "breadcrumb-elements",
      className: "flex items-center gap-[16px] font-sans text-p-12 font-normal leading-7 text-action-primary"
    }, props.breadcrumbElements.map(function (breadcrumb, index) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, index !== 0 && /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement(SvgBreadcrumbRightArrow, null)), /*#__PURE__*/React__default.createElement("li", {
        "automation-id": "breadcrumb-element-".concat(index),
        key: index
      }, breadcrumb));
    }));
  } else {
    return (
      /*#__PURE__*/
      /* Should this not be a link or button? */
      React__default.createElement("div", {
        "automation-id": "breadcrumb-back-arrow",
        className: "flex items-center gap-[16px] font-sans text-p-12 font-normal leading-7 text-action-primary"
      }, /*#__PURE__*/React__default.createElement(SvgBreadcrumbLeftArrow, null), props.backLink)
    );
  }
};

export { ArticleBreadcrumbs };
//# sourceMappingURL=article-bread-crumbs.esm.js.map
